import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import {
  VerifyYourAccountModal,
} from '../../../insurance/reimbursement/VerifyYourAccountModal';
import { UpdateReimbursementModal } from '../UpdateReimbursementModal';

import {
  useReimbursementValidations,
} from '../../../insurance/reimbursement/hooks';
import { globalContactUsModalToggled } from '../../../../actions';

import '../css/ReimbursementMultibrandList.css';

const ReimbursementMultibrandCard = ({
  endDate = '',
  handleOnClickCard = () => {},
  loadingClaims = false,
  logo = null,
  marketChannelId = 0,
  petsInPolicy = [],
  policyNumber = '',
  startDate = '',
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('myAccount');
  const [verifyAccounModalVisible, setVerifyAccountVisible] = useState(false);
  const [
    contactInformationMissingModalVisible,
    setContactInformationMissingModalVisible,
  ] = useState(false);

  const {
    doSendVerificationCode,
    doVerifyCode,
    errorMessage,
    getContactMethod,
    getMaskedContact,
    loading,
    missingContactInformation,
    remainingSeconds,
    shouldVerifyReimbursement,
    verified,
  } = useReimbursementValidations();

  const onCloseVerifyModal = useCallback(() => {
    setVerifyAccountVisible(false);
  }, []);

  const onCloseContactInformationMissing = useCallback(() => {
    setContactInformationMissingModalVisible(false);
  }, []);

  const onContactUsClick = useCallback(() => {
    onCloseContactInformationMissing();
    dispatch(globalContactUsModalToggled());
  }, [onCloseContactInformationMissing]);

  const onCardClick = useCallback(() => {
    if (shouldVerifyReimbursement(marketChannelId)) {
      if (missingContactInformation(marketChannelId)) {
        setContactInformationMissingModalVisible(true);
        return;
      }

      setVerifyAccountVisible(true);
      return;
    }

    // othwewise, we just open the reimbursement method screen regularly
    handleOnClickCard();
  }, [handleOnClickCard, marketChannelId]);

  useEffect(() => {
    if (verified) {
      onCloseVerifyModal();
      // regular flow
      handleOnClickCard();
    }
  }, [verified, onCloseVerifyModal]);

  return (
    <div className="Reimbursement-multibrand-card">
      <div className="Reimbursement-multibrand-left-content">
        <img
          alt=""
          src={logo}
        />

        <div className="Reimbursement-multibrand-card-info-wrapper">
          <div className="Reimbursement-multibrand-card-info-container">
            <span className="Reimbursement-multibrand-card-info-title">
              {t('reimbursementSection.policyNumber')}
            </span>

            <span className="Reimbursement-multibrand-card-info-value">
              {policyNumber}
            </span>
          </div>

          <div className="Reimbursement-multibrand-card-info-container">
            <span className="Reimbursement-multibrand-card-info-title">
              {t('reimbursementSection.policyTerm')}
            </span>

            <span className="Reimbursement-multibrand-card-info-value">
              {`${startDate} - ${endDate}`}
            </span>
          </div>

          <div className="Reimbursement-multibrand-card-info-container">
            <span className="Reimbursement-multibrand-card-info-title">
              {t('reimbursementSection.petsOnThisPolicy')}
            </span>

            <span className="Reimbursement-multibrand-card-info-value">
              {petsInPolicy.map((pet) => pet.PetName).join(', ')}
            </span>
          </div>
        </div>
      </div>

      <button
        className="Reimbursement-multibrand-card-details-button"
        disabled={loadingClaims}
        onClick={onCardClick}
        type="button"
      >
        <span>{t('reimbursementSection.viewDetails')}</span>
      </button>

      <VerifyYourAccountModal
        contactMethod={getContactMethod(marketChannelId)}
        errorMessage={errorMessage}
        loading={loading}
        maskedContact={getMaskedContact(marketChannelId)}
        onClose={onCloseVerifyModal}
        onSendCode={doSendVerificationCode(marketChannelId)}
        onVerifyCode={doVerifyCode(marketChannelId)}
        remainingSeconds={remainingSeconds}
        visible={verifyAccounModalVisible}
      />

      <UpdateReimbursementModal
        onButtonClick={onContactUsClick}
        onClose={onCloseContactInformationMissing}
        show={contactInformationMissingModalVisible}
      />
    </div>
  );
};

export { ReimbursementMultibrandCard };
